import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Card, Input, Button, Modal, message, Select } from "antd";
import { req_list_pim_bunchLog_staff, req_del_pim_bunchLog_staff } from "../../api";
import { getTodayDate, formateDateDbT } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
class BunchLogStaff extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: window.innerWidth,
    bunchDate: getTodayDate(),
    searchField: "None",
    searchValue: "",
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    item: {},
    isShowFlexibleApplyModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { searchField, searchValue, bunchDate } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    const result = await req_list_pim_bunchLog_staff(
      userLevel,
      userCode,
      searchField,
      searchValue,
      bunchDate,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_detete_item = async (item) => {
    const { Uid } = item;
    const { token, userCode } = this.props.user;

    const result = await req_del_pim_bunchLog_staff(Uid, userCode, token);
    if (result.status === "success") {
      message.success(result.message);
      this.api_item_list();
    } else {
      message.error(result.message);
    }
  };

  // 樣式設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_item_list();
  };

  handle_btn_delete = (item) => {
    const { Uid } = item;
    const { userCode } = this.props.user;
    const row = {
      Uid: Uid,
      Code: userCode,
    };
    Modal.confirm({
      title: `您確定刪除此筆資料嗎，將無法回復?`,
      onOk: () => {
        this.api_detete_item(row);
      },
    });
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "操作",
        width: "80px",
        fixed: "true",
        align: "center",
        render: (item) => (
          <>
            <button
              className="btn btn-success btn-sm"
              style={{ width: "80px" }}
              onClick={() => this.handle_btn_delete(item)}
            >
              <i className="fas fa-calendar-minus"></i> 刪除
            </button>
          </>
        ),
      },
      {
        title: "職號",
        dataIndex: "StaffCode",
        key: "StaffCode",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "姓名",
        dataIndex: "StaffTwName",
        key: "StaffTwName",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "打卡日期",
        dataIndex: "BunchDate",
        key: "StaffName",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "打卡時間",
        dataIndex: "BunchTime",
        key: "BunchTime",
        align: "center",
        width: 160,
        render: (text) => <><span style={{ fontSize: "1.5em", fontWeight: "bold", color: "blue" }}>{formateDateDbT(text)}</span></>,
      },
    ];
  };

  ///////////////////////////////////////////////////////////
  render() {
    const { data, loading, searchField, searchValue } = this.state;
    const title = (
      <div>
        <Input style={{ width: 100 }} value={this.state.bunchDate} onChange={(event) => this.setState({ bunchDate: event.target.value })}></Input>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">請選擇</Select.Option>
          <Select.Option value="StaffCode">職號</Select.Option>
          <Select.Option value="StaffTwName">姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_item_list()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-sync-alt"></i>
        </Button>{" "}
      </div>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          rowKey="Uid"
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(BunchLogStaff);
